import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthService } from 'src/app/shared/services/auth.service';

/**
 * AVD-only token guard.
 *
 * Dedicated guard for the standalone /avd view - mirrors TokenGuard but kept
 * separate so the AVD route does not depend on the dashboard guards. Waits for the
 * Firebase token (used as the gateway bearer) to be ready before activating.
 */
@Injectable({ providedIn: 'root' })
export class AvdTokenGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  /** AVD users always return to the AVD login route. */
  private readonly loginRoute = '/login/avd';

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.token$.pipe(
      filter(token => token !== null),
      take(1),
      map(token =>
        token ? true : this.router.createUrlTree([this.loginRoute])
      )
    );
  }
}
